import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InvestpackService } from '@app/investment/investpack.service';
import { AlertService } from '@service/alert.service';
import { BrokrageService } from '@service/brokrage.service';
import { FireAnalyticsService } from '@service/fire-analytics.service';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-rebalance',
  templateUrl: './rebalance.component.html',
  styles: [
  ]
})
export class RebalanceComponent implements OnInit {

  rebalanceInstruments: any[] = [];
  subscriptionData: any;
  totalAmount: number = 0;
  disablebtn: boolean = false
  currentUser: any = {}
  isNotInvested: boolean = false;
  calculatedValue: any;
  constructor(
    private dialogRef: MatDialogRef<RebalanceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { instruments: any[], subscription: any, currentUser: any, marketEnded: boolean },
    private investpackService: InvestpackService,
    private analytics: FireAnalyticsService,
    private alertService: AlertService,
    private brokerService: BrokrageService,
  ) { }

  ngOnInit(): void {
    this.subscriptionData = this.data.subscription;
    if (!this.subscriptionData.isInvested) {
      this.isNotInvested = true
    }
    this.rebalanceInstruments = this.data.instruments.filter((x) => x.activity);
    this.currentUser = this.data.currentUser
    this.totalAmount = this.rebalanceInstruments.reduce((a, b) => a + (b.investment || 0), 0)
    this.calculateValue();
  }


  close(value?) {
    if (value === 'external') {
      this.analytics.logEvents('Rebalanced Outside', { investpack: this.subscriptionData.wealthcase.name });
    }
    this.dialogRef.close(value)
  }

  rebalance() {
    if (this.brokerService.checkBrokerStatus(this.currentUser)) {
      if (this.subscriptionData.wealthcase.type !== 'aum') {
        this.rebalanc()
      } else {
        this.aumRebalance()
      }
    }
    else {
      this.brokerService.gotoBrokerLogin(this.currentUser.brokerageOptions[0])
    }
  }

  rebalanc() {
    let instruments: any[] = []
    this.rebalanceInstruments.forEach((element) => {
      if (element.quantity > 0) {
        let category: string = 'cash'
        if (element.category === 'cash' && !element.isGold && !element.isEtf) {
          category = 'cash'
        } else if (element.category === 'cash' && element.isGold && !element.isEtf) {
          category = 'gold'
        } else if (element.category === 'cash' && !element.isGold && element.isEtf) {
          category = 'etf'
        } else {
          category = 'mutual_fund'
        }
        let instruData = {
          tradingSymbol: element.tradingSymbol,
          exchange: element.exchange,
          quantity: element.quantity,
          investment: element.investment,
          scriptType: "BUY",
          orderStatus: "success",
          validity: "DAY",
          price: element.currentPrice,
          category: element.category,
          weight: element.weight ? element.weight : 0
        }
        if (element.scriptType) {
          instruData.scriptType = element.scriptType
        } else {
          if (element.newQuantity) {
            if ((element.newQuantity - element.quantity) > 0) {
              instruData.scriptType = "BUY"
            } else {
              instruData.scriptType = "SELL"
            }
          } else {
            instruData.scriptType = "BUY"
          }
        }
        instruData.quantity = instruData.quantity;
        instruData.price = instruData.price;
        instruments.push(instruData)
      }
    })
    const data = {
      subscription: this.subscriptionData._id,
      investments: this.totalAmount,
      skipEquities: false,
      instruments: instruments,
    };
    this.disablebtn = true;
    this.investpackService.rebalanceInstruments(data)
      .pipe(finalize(() => this.disablebtn = false))
      .subscribe({
        next: (res) => {
          let user = JSON.parse(window.localStorage.getItem('userProfile'))
          this.analytics.logEvents('Rebalance Investment', { broker: user.brokerageOptions[0], investpack: this.subscriptionData.wealthcase.name });
          this.alertService.success(res.message);
          if (this.currentUser.brokerageOptions.indexOf('zerodha') > -1) {
            this.placeInZerodha(res.data)
          }
          if (this.currentUser.brokerageOptions.indexOf('upstox') > -1) {
            if (!this.brokerService.checkBrokerStatus(this.currentUser)) {
              this.brokerService.gotoBrokerLogin('upstox')
            }
            else {
              this.placeInUpstox(res.data)
            }
          } else {
            this.close('rebalance')
          }
        },
        error: (err) => {
          this.brokerService.handleRelogin(err, this.currentUser)
        }
      });
  }

  aumRebalance() {
    const data = {
      wealthcase: this.subscriptionData.wealthcase._id,
      subscription: this.subscriptionData._id,
      skipEquities: false
    };
    this.disablebtn = true;
    this.investpackService.rebalanceAumInstruments(data)
      // .pipe(finalize(() => this.disablebtn = false))
      .subscribe({
        next: (res) => {
          let user = JSON.parse(window.localStorage.getItem('userProfile'))
          this.analytics.logEvents('Aum Rebalance Investment', { broker: user.brokerageOptions[0], investpack: this.subscriptionData.wealthcase.name });
          this.alertService.success(res.message);
          if (this.currentUser.brokerageOptions.indexOf('zerodha') > -1) {
            this.placeInZerodha(res.data)
          }
          if (this.currentUser.brokerageOptions.indexOf('upstox') > -1) {
            if (!this.brokerService.checkBrokerStatus(this.currentUser)) {
              this.brokerService.gotoBrokerLogin('upstox')
            }
            else {
              this.placeInUpstox(res.data)
            }
          }
          else {
            this.close('rebalance')
          }
          this.disablebtn = false;
        },
        error: (err) => {
          this.brokerService.handleRelogin(err, this.currentUser)
          this.disablebtn = false;
        }
      })

  }

  placeInZerodha(reblanceData) {
    let orders: any[] = []
    let mfOrders: any[] = []
    reblanceData.forEach(call => {
      if (call.category !== 'mutual_fund' && call.quantity) {
        const newInstrument = {
          tradingsymbol: call.tradingSymbol,
          exchange: call.exchange,
          variety: 'regular',
          transaction_type: 'BUY',
          order_type: 'MARKET',
          product: 'CNC',
          price: call.currentPrice,
          quantity: call.quantity,
          readonly: false,
          tag: call.zerodhaTag,
        };
        if (call.scriptType) {
          newInstrument.transaction_type = call.scriptType;
        } else if (call.activity === 'decrease' || call.activity === 'exit') {
          newInstrument.transaction_type = 'SELL';
        }
        orders.push(newInstrument);
      } else {
        mfOrders = reblanceData.filter((x) => x.category === 'mutual_fund');
      }
    });
    let currOrders: any = {
      orders: JSON.stringify(reblanceData),
      subscriptionId: this.subscriptionData._id,
      type: 'wealthcase'
    }
    if (mfOrders.length) {
      currOrders.mfOrders = mfOrders
    }
    window.localStorage.setItem('subscription', JSON.stringify(currOrders))
    this.close('rebalance')
    this.brokerService.zerodhaOrderPlace(orders)
  }

  placeInUpstox(reblanceData) {
    let orders: any[] = []
    let mfOrders: any[] = []
    reblanceData.forEach(call => {
      if (call.category !== 'mutual_fund' && call.quantity) {
        const newInstrument = {
          is_amo: false,
          instrument_token: call.upstoxInstrumentKey,
          validity: 'DAY',
          transaction_type: 'BUY',
          order_type: 'MARKET',
          quantity: call.quantity,
          product: 'D',
          tag: call.upstoxTag
        };
        if (call.scriptType) {
          newInstrument.transaction_type = call.scriptType;
        } else if (call.activity === 'decrease' || call.activity === 'exit') {
          newInstrument.transaction_type = 'SELL';
        }
        orders.push(newInstrument);
      } else {
        mfOrders = reblanceData.filter((x) => x.category === 'mutual_fund');
      }
    });
    let currOrders: any = {
      orders: JSON.stringify(reblanceData),
      subscriptionId: this.subscriptionData._id,
      type: 'wealthcase'
    }
    if (mfOrders.length) {
      currOrders.mfOrders = mfOrders
    }
    window.localStorage.setItem('subscription', JSON.stringify(currOrders))
    this.close('rebalance')
    this.brokerService.upstoxOrderPlace(orders, this.currentUser.upstox.accessToken, `/investment/investpack/${this.subscriptionData.wealthcase._id}`)
  }

  decreaseIncreaseQty(stock, type) {
    if (type == 'decrease') {
      if (stock.category == 'mutual_fund') {
        stock.investment = stock.investment - 1
      } else {
        stock.quantity = stock.quantity - 1
      }
    } else if (type == 'increase') {
      if (stock.category == 'mutual_fund') {
        stock.investment = stock.investment + 1
      } else {
        stock.quantity = stock.quantity + 1
      }
    }
    this.calculateValue();
  }
  calculateValue() {
    let _buy: number = 0;
    let _sell: number = 0;
    this.rebalanceInstruments.forEach((obj: any) => {
      if (obj.scriptType == 'BUY') {
        _buy = _buy + obj.quantity * obj.currentPrice;
      }
      else {
        _sell = _sell + obj.quantity * obj.currentPrice;
      }
    })
    this.calculatedValue = {
      'sellAmount': _sell,
      'buyAmount': _buy,
      'requiredInDemat': _buy - ((_sell * 60) / 100)
    }
  }
}
